<div class="container p-0">
  <div class="row justify-content-center">
    <div class="col-sm-6 col-xs-12  col-12 mt-4 " >
      <img [src]="img" alt="Tik Tok" style="width: inherit;">


    </div>


  </div>

  <div class="row justify-content-center">
    <button type="button" class="btn btn-block btn-success btn-lg
    col-lg-5 col-sm-5 col-xs-11 col-11 mt-4"
    (click)="textWhats()">Fale com a Gente!</button>
  </div>
</div>
